/* eslint-disable import/no-unresolved */
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/lib/styles/main.css';
import { createVuetify } from 'vuetify';
import DateFnsAdapter from '@date-io/date-fns';
import koKr from 'date-fns/locale/ko';
import enUs from 'date-fns/locale/en-US';
import { useI18n } from 'vue-i18n';
import i18n from '@/i18n';
import { createVueI18nAdapter } from 'vuetify/lib/locale/adapters/vue-i18n';
import { VNumberInput } from 'vuetify/labs/VNumberInput';
import { VDateInput } from 'vuetify/labs/VDateInput';

const vuetify = createVuetify({
  components: {
    VNumberInput,
    VDateInput,
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      ko: koKr,
      en: enUs,
    },
    formats: 'keyboardDate',
  },
});

export default vuetify;
